import { render } from "./DocumentDetailPage.vue?vue&type=template&id=12716ab8&scoped=true"
import script from "./DocumentDetailPage.vue?vue&type=script&lang=js"
export * from "./DocumentDetailPage.vue?vue&type=script&lang=js"

import "./DocumentDetailPage.vue?vue&type=style&index=0&id=12716ab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12716ab8"]])

export default __exports__